/* global HTMLElement */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { Suspense, useEffect, useState } from "react";
import ChartTypes from "../utils/ChartTypes";
import findIndex from "lodash/findIndex";
import ExtensionTemplate from "./templates/ExtensionTemplate";
import { injectIntl } from "react-intl";
import { NotLoggedInError, DisclaimerNotEndorsedError } from "../utils/error";
import RotateDevicePrompt from "./RotateDevicePrompt";
import ChartError from "./ChartError";
var ChartRenderer = function(props) {
    var pushError = function pushError(newError) {
        var _errors = errors.slice();
        if (_instanceof(newError, Error) && !_errors.find(function(e) {
            return e.message === newError.message || e.status === newError.status;
        })) {
            _errors.push(newError);
            setErrors(_errors);
        } else if (newError) {
            // if something is pushed which isn't an Error, better to show it than to swallow it, even if we do not know what it is
            console.error(newError);
        }
    };
    var fetchContent = props.fetchContent, fetchClaims = props.fetchClaims, fetchGroups = props.fetchGroups, fetchUsers = props.fetchUsers, complete = props.complete, evaluateInteraction = props.evaluateInteraction, acceptDisclaimer = props.acceptDisclaimer, login = props.login, progress = props.progress, chart = props.chart, claims = props.claims, content = props.content, isLoadingContent = props.isLoadingContent, noteGroup = props.noteGroup, socialConfig = props.socialConfig, session = props.session, student = props.student, completed = props.completed, users = props.users, engagementServerEnabled = props.engagementServerEnabled, chartType = props.chartType, isLoadingClaims = props.isLoadingClaims, isEvaluated = props.isEvaluated, exam = props.exam, connections = props.connections, currentNode = props.currentNode, fetchExamInteractions = props.fetchExamInteractions, examInteractions = props.examInteractions, intl = props.intl;
    var _useState = _slicedToArray(useState([]), 2), errors = _useState[0], setErrors = _useState[1];
    var checkNotLoggedInErrors = function(errors) {
        var newErrors = errors.slice();
        if (session) {
            var index = findIndex(newErrors, function(e) {
                return e.constructor === NotLoggedInError;
            });
            index > -1 && newErrors.splice(index, 1);
        }
        setErrors(newErrors);
        // Check again for Disclaimer changes which are stored in socialConfig
        if (socialConfig) {
            checkDisclaimerErrors(newErrors);
        }
    };
    var checkDisclaimerErrors = function(errors) {
        var _socialConfig_disclaimer;
        var newErrors = errors.slice();
        if (session && (socialConfig === null || socialConfig === void 0 ? void 0 : (_socialConfig_disclaimer = socialConfig.disclaimer) === null || _socialConfig_disclaimer === void 0 ? void 0 : _socialConfig_disclaimer.needs_endorsement) && session.is_disclaimer_endorsed) {
            var index = findIndex(errors, function(e) {
                return e.constructor === DisclaimerNotEndorsedError;
            });
            index > -1 && newErrors.splice(index, 1);
        }
        setErrors(newErrors);
    };
    useEffect(function() {
        if (chart) {
            if (!content) {
                fetchContent(chart.target_id, chart.target_type, chart.id);
            }
            if (!claims) {
                fetchClaims(chart.target_id);
            }
        }
        if (session) {
            checkNotLoggedInErrors(errors);
        }
    }, []);
    useEffect(function() {
        if (completed) {
            progress();
        }
    }, [
        completed
    ]);
    useEffect(function() {
        // chart has changed, content has not yet been loaded and also has not started loading yet
        if (chart && !content && !isLoadingContent) {
            fetchContent(chart.target_id, chart.target_type, chart.id);
        }
        if (chart && chart.target_type === "Exam" && examInteractions.length === 0) {
            fetchExamInteractions(chart.id, currentNode === null || currentNode === void 0 ? void 0 : currentNode.target_id);
        }
    }, [
        chart
    ]);
    useEffect(function() {
        // Login user to engagement server if enabled once we have student data
        if (engagementServerEnabled && student && student.id && student.name) {
            login();
        }
    }, [
        student,
        engagementServerEnabled
    ]);
    useEffect(function() {
        // Once user is logged in to engagement server and disclaimer is OK, fetch users and groups
        if (engagementServerEnabled && session && socialConfig) {
            if (session) {
                checkNotLoggedInErrors(errors);
            }
            if (socialConfig.disclaimer.needs_endorsement && session.is_disclaimer_endorsed || !socialConfig.disclaimer.needs_endorsement) {
                if (!noteGroup) {
                    fetchGroups();
                }
                if (!users.length) {
                    fetchUsers();
                }
            }
        }
    }, [
        session,
        socialConfig
    ]);
    useEffect(function() {
        // Scroll divs up on chart change
        var scrollDivs = [
            document.querySelector(".clientcss__body"),
            document.querySelector(".chart")
        ];
        scrollDivs.forEach(function(elem) {
            if (elem) {
                elem.scrollTop = 0;
            }
        });
        // Reset errors on chart change
        setErrors([]);
    }, [
        content
    ]);
    var renderChart = function() {
        var _socialConfig_disclaimer;
        var Template = chartType ? chartType !== "ExtensionPage" && ChartTypes[chartType] ? ChartTypes[chartType].template : null : null;
        // iframe remark: we need a unique key for each iFrame, so the DOM gets updated instantly.
        return /*#__PURE__*/ React.createElement("main", {
            id: "main",
            tabIndex: 0,
            className: "chart-renderer".concat(isEvaluated ? " chart-is-evaluated" : "")
        }, /*#__PURE__*/ React.createElement(Suspense, {
            fallback: /*#__PURE__*/ React.createElement("div", {
                className: "chart-renderer chart-renderer--is-loading"
            })
        }, chartType === "ExtensionPage" ? errors.length === 0 ? /*#__PURE__*/ React.createElement(ExtensionTemplate, _extends({}, props, {
            key: chart === null || chart === void 0 ? void 0 : chart.id,
            pushError: pushError,
            complete: function() {
                return !!chart && !!complete && complete(chart.id);
            }
        })) : /*#__PURE__*/ React.createElement(ChartError, {
            errors: errors,
            intl: intl,
            engagementServerEnabled: engagementServerEnabled,
            updateErrors: function() {
                return setErrors(errors.slice(1));
            },
            disclaimerText: (socialConfig === null || socialConfig === void 0 ? void 0 : (_socialConfig_disclaimer = socialConfig.disclaimer) === null || _socialConfig_disclaimer === void 0 ? void 0 : _socialConfig_disclaimer.languages[intl.locale]) || "No disclaimer text found.",
            acceptDisclaimer: function() {
                acceptDisclaimer();
            }
        }) : Template ? /*#__PURE__*/ React.createElement(Template, _extends({}, props, {
            key: chart === null || chart === void 0 ? void 0 : chart.id,
            complete: function() {
                return !!chart && !!complete && complete(chart.id);
            },
            evaluateInteraction: function(correct, selectedAnswers, interactionType) {
                if (chart && exam) {
                    evaluateInteraction(chart === null || chart === void 0 ? void 0 : chart.id, exam && exam.id, correct, selectedAnswers, interactionType);
                }
            },
            socialConnectionEstablished: !!connections.tweet
        })) : null, (content === null || content === void 0 ? void 0 : content.show_rotate_device_prompt) ? /*#__PURE__*/ React.createElement(RotateDevicePrompt, null) : null));
    };
    // Render chart if content and claims have been loaded, we have a chart type, and we either have the chart content or we are inside an exam
    var shouldRenderChart = Boolean(!isLoadingContent && !isLoadingClaims && chartType && (content || chartType === "Exam"));
    return shouldRenderChart ? renderChart() : /*#__PURE__*/ React.createElement("div", {
        className: "chart-renderer chart-renderer--is-loading"
    });
};
export var Component = ChartRenderer;
export default injectIntl(ChartRenderer);
